import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import ColumnSelection from "./ColumnSelection";
import ConfigPopup from "./ConfigPopup";
import heartLoading from "../../../../assests/heartLoading.gif";
import {
  AssetSelectionSidebar,
  SelectedItemsPanel,
} from "../../onBoardingAsset/components/AssetSelectionContent";
import {
  filterTree,
  getAllSelectableItems,
} from "../../onBoardingAsset/components/AssetSelectionHelpers";

const TABS = [
  { key: "adls", label: "ADLS" },
  { key: "uc", label: "Unity Catalog" },
  { key: "manual", label: "Manual Upload" },
  { key: "uc_gcp", label: "UC GCP" },
];

const isSelectableItem = (item, source) => {
  if (source === "uc" || source === "uc_gcp") {
    return !item.children || item.type === "table";
  }
  if (source === "adls") {
    return true;
  }
  return false;
};

const AssetSelectionModal = ({
  id,
  selectedSources = [],
  nextStep,
  previousStep,
  region,
  country,
  columnScreen,
}) => {
  const availableTabs = TABS.filter((tab) => selectedSources.includes(tab.key));
  const [activeTab, setActiveTab] = useState(availableTabs[0]?.key || "adls");
  const [data, setData] = useState({ ADLS: [], UC: [], UCGCP: [] });
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDragActive, setIsDragActive] = useState(false);
  const [editingNames, setEditingNames] = useState({});
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [configuringFileId, setConfiguringFileId] = useState(null);
  const [isFile, setIsFile] = useState(false);
  const [configuringFileName, setConfiguringFileName] = useState(null);
  const [configuringFileSource, setConfiguringFileSource] = useState(null);
  const [fileConfigurations, setFileConfigurations] = useState({});
  const [isEditingExistingConfig, setIsEditingExistingConfig] = useState(false);
  const [configForm, setConfigForm] = useState({
    assetName: "",
    assetDescription: "",
    dataAssetOwner: "",
    dataframeName: "",
    region: "",
    market: "",
    technicalDataSteward: "",
    completeness: "",
    accuracy: "",
    consistency: "",
    uniqueness: "",
    freshness: "0",
    validity: "",
    sampleSize: 10,
    tags: [],
    frequency: "",
    startDate: "",
    endDate: "",
    time: "",
    daysOfWeek: [],
    dayOfMonth: "",
    selectedPeriods: [],
  });
  const [formErrors, setFormErrors] = useState({});
  const [columnModalOpen, setColumnModalOpen] = useState(
    columnScreen ? true : false
  );
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [onboardindDetails, setOnboardingDetails] = useState({});
  const [regionsCountriesData, setRegionsCountriesData] = useState([]);
  const [columnSubmitting, setColumnSubmitting] = useState(false);
 

  useEffect(() => {
    const fetchEditData = async () => {
      if (!id) return;
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/edit-form/${id}`
        );
        if (response.status === 200 && response.data) {
          const data = response.data;
          setOnboardingDetails(data);
        }
      } catch (error) {
        toast.error("Failed to fetch product for editing");
      } finally {
        setLoading(false);
      }
    };
    fetchEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const adlsData = useMemo(() => data.ADLS || [], [data.ADLS]);
  const ucData = useMemo(() => data.UC || [], [data.UC]);
  const ucGcpData = useMemo(() => data.UCGCP || [], [data.UCGCP]);
  const [columnsList, setColumnList] = useState([]);

  console.log("data in details", onboardindDetails);

  const [assetNameCheckMessage, setAssetNameCheckMessage] = useState("");
  const [assetNameIsUnique, setAssetNameIsUnique] = useState(undefined);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [allFieldsValid, setAllFieldsValid] = useState(true);
  const [formTouched, setFormTouched] = useState(false);
  const [ErrorMessage, SetErrorMessage] = useState({});
  let debounceTimeout = null;

  useEffect(() => {
    let isMounted = true;
    const fetchAllData = async () => {
      setLoadingAssets(true);
      try {
        const [browsingRes, selectionRes, regionsCountriesRes] =
          await Promise.all([
            axios.get(`${process.env.REACT_APP_API_URL}/assets/list/${id}`),
            axios.get(
              `${process.env.REACT_APP_API_URL}/get-data-asset-details/${id}`
            ),
            axios.get(
              `${process.env.REACT_APP_API_URL}/regions-countries-list/`
            ),
          ]);

        let processedData = { ADLS: [], UC: [], UCGCP: [] };
        SetErrorMessage(browsingRes.data?.message || {});
        if (browsingRes.data) {
          if (browsingRes.data.adls || browsingRes.data.ADLS) {
            processedData.ADLS =
              browsingRes.data.adls || browsingRes.data.ADLS || [];
            // processedData.ADLS = processedData.ADLS.flatMap(d => d.assets);
          }
          if (browsingRes.data.uc || browsingRes.data.UC) {
            processedData.UC = browsingRes.data.uc || browsingRes.data.UC || [];
            // processedData.UC = processedData.UC.flatMap(d => d.tables);
          }
          if (browsingRes.data.uc_gcp || browsingRes.data.UC_GCP) {
            processedData.UCGCP = browsingRes.data.uc_gcp || browsingRes.data.UC_GCP || [];
            // processedData.UCGCP = processedData.UCGCP.flatMap(d => d.tables);
          }
          if (Array.isArray(browsingRes.data)) {
            processedData.ADLS = browsingRes.data;
            // processedData.ADLS = processedData.ADLS.flatMap(d => d.assets);
          }
        }
        if (isMounted) setData(processedData);

        if (regionsCountriesRes.data && isMounted) {
          setRegionsCountriesData(regionsCountriesRes.data);
        }

        if (selectionRes.data) {
          const { selectedFolders = [], uploadedFiles = [] } =
            selectionRes.data;
          if (isMounted) {
            const normalizedSelectedFolders = selectedFolders.map((item) => ({
              ...item,
              path: item.path || item.full_path || item.name,
              source: item.source || "adls",
              type: item.type || "table",
              full_path: item.full_path || item.path,
            }));

            const normalizedUploadedFiles = uploadedFiles.map((item) => ({
              ...item,
              id: item.id || item.dataAssetId || item.name,
              name: item.name,
              path: item.path,
            }));

            setSelectedFolders(normalizedSelectedFolders);
            setUploadedFiles(normalizedUploadedFiles);

            const normalizeConfig = (config) => {
              if (!config) return null;

              const validDays = [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat",
              ];
              const validPeriods = Array.from(
                { length: 13 },
                (_, i) => `P${i + 1}`
              );

              const safeToString = (val) => {
                if (val === null || val === undefined || val === "") return "";
                if (val === "N/A") return "";
                return String(val);
              };

              return {
                assetName: config.assetName || "",
                assetDescription: config.assetDescription || "",
                dataAssetOwner: config.dataAssetOwner || "",
                dataframeName: config.dataframeName || "",
                region: config.region || "",
                market: config.market || "",
                technicalDataSteward: config.technicalDataSteward || "",
                daysOfWeek: config.daysOfWeek
                  ? typeof config.daysOfWeek === "string"
                    ? config.daysOfWeek
                        .split(",")
                        .map((d) => d.trim())
                        .filter((d) => d && validDays.includes(d))
                    : Array.isArray(config.daysOfWeek)
                    ? config.daysOfWeek
                    : []
                  : [],
                // Convert selectedPeriods from null/string to array
                selectedPeriods: config.selectedPeriods
                  ? typeof config.selectedPeriods === "string"
                    ? config.selectedPeriods
                        .split(",")
                        .map((p) => p.trim())
                        .filter((p) => p && validPeriods.includes(p))
                    : Array.isArray(config.selectedPeriods)
                    ? config.selectedPeriods
                    : []
                  : [],
                // Convert tags from null/string to array
                tags: config.tags
                  ? typeof config.tags === "string"
                    ? config.tags
                        .split(",")
                        .map((t) => t.trim())
                        .filter((t) => t)
                    : Array.isArray(config.tags)
                    ? config.tags
                    : []
                  : [],
                // Ensure numeric fields are strings for form inputs
                completeness: safeToString(config.completeness),
                accuracy: safeToString(config.accuracy),
                consistency: safeToString(config.consistency),
                uniqueness: safeToString(config.uniqueness),
                freshness: safeToString(config.freshness),
                validity: safeToString(config.validity),
                sampleSize: config.sampleSize
                  ? String(config.sampleSize)
                  : "10",
                // Handle date fields
                startDate: config.startDate || "",
                endDate: config.endDate || "",
                // Handle frequency
                frequency: safeToString(config.frequency),
                // Handle time
                time: config.time || "00:00:00",
                dayOfMonth: config.dayOfMonth ? String(config.dayOfMonth) : "",
              };
            };

            const newConfigs = {};
            normalizedSelectedFolders.forEach((f) => {
              if (f.configuration)
                newConfigs[f.path] = normalizeConfig(f.configuration);
            });
            normalizedUploadedFiles.forEach((f) => {
              if (f.configuration)
                newConfigs[f.id] = normalizeConfig(f.configuration);
            });

            setFileConfigurations(newConfigs);
          }
        } else {
          if (isMounted) {
            setSelectedFolders([]);
            setUploadedFiles([]);
            setFileConfigurations({});
          }
        }
      } catch (error) {
        toast.error("Failed to fetch asset or selection data.");
      } finally {
        if (isMounted) setLoadingAssets(false);
      }
    };
    fetchAllData();
    return () => {
      isMounted = false;
    };
  }, [id]);

  useEffect(() => {
    if (availableTabs.length > 0) {
      setActiveTab(availableTabs[0].key);
    }
  }, [selectedSources]);

  const processFiles = (files) => {
    const newFiles = Array.from(files).map((file) => ({
      file,
      id: `${file.name}-${file.lastModified}-${Math.random()}`,
      // defaultName: file.name,
      name: file.name,
      // isEditing: false,
      size: file.size,
      lastModified: file.lastModified,
      type: file.type,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setIsDragActive(true);
    } else if (e.type === "dragleave") {
      setIsDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const csvFiles = Array.from(e.dataTransfer.files).filter((file) =>
        file.name.endsWith(".csv")
      );
      if (csvFiles.length > 0) {
        processFiles(csvFiles);
      } else {
        toast.error("Only CSV files are accepted.");
      }
      e.dataTransfer.clearData();
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      processFiles(e.target.files);
    }
  };

  const normalizePath = (path) => {
    if (!path) return "";
    return path
      .replace(/\./g, "/")
      .replace(/\\/g, "/")
      .toLowerCase()
      .trim();
  };
  
  const handleItemSelect = (item, shouldSelect) => {
    if (!isSelectableItem(item, item.source)) {
      return;
    }
  
    const targetPath = normalizePath(item.path || item.full_path);
  
    setSelectedFolders((prev) => {
      if (shouldSelect) {
        if (
          prev.some(
            (selected) =>
              selected.source === item.source &&
              normalizePath(selected.path || selected.full_path) === targetPath
          )
        ) {
          return prev;
        }
  
        return [...prev, { ...item }];
      }
  
      return prev.filter(
        (selected) =>
          !(
            selected.source === item.source &&
            normalizePath(selected.path || selected.full_path) === targetPath
          )
      );
    });
  };

  const handleSelectAll = () => {
     const currentData =
       activeTab === "adls"
         ? adlsData
         : activeTab === "uc"
         ? ucData
         : activeTab === "uc_gcp"
         ? ucGcpData
         : [];
   
     const allItems = getAllSelectableItems(
       currentData,
       activeTab,
       isSelectableItem
     );
   
     const removeDuplicateRoot = (path) => {
       const parts = path.split("/");
   
       while (parts.length > 1 && parts[0] === parts[1]) {
         parts.splice(1, 1);
       }
   
       return parts.join("/");
     };
   
     const newSelected = allItems
   .filter((item) => {
     let itemPath = normalizePath(item.path || item.full_path);
     itemPath = removeDuplicateRoot(itemPath);
 
     return !selectedFolders.some((sel) => {
       let selPath = normalizePath(sel.path || sel.full_path);
       selPath = removeDuplicateRoot(selPath);
 
       return sel.source === item.source && selPath === itemPath;
     });
   })
   .map((item) => {
     let cleanedPath = normalizePath(item.path || item.full_path);
     cleanedPath = removeDuplicateRoot(cleanedPath);
 
     return {
       ...item,
       path: cleanedPath,
       full_path: cleanedPath,
     };
   });
 
   setSelectedFolders((prev) => [...prev, ...newSelected]);
   };

  const handleClear = () => {
    const source = activeTab;
    setSelectedFolders((prev) => prev.filter((item) => item.source !== source));
  };

  const handleRemoveFolder = (path) => {
    setSelectedFolders((prev) => prev.filter((folder) => folder.path !== path));
  };

  const handleRemoveFile = (id) => {
    setUploadedFiles((prev) => prev.filter((fileObj) => fileObj.id !== id));
  };

  const handleSave = async () => {
    // Validation check
    const allItemsHaveNames =
      selectedFolders.every((folder) => folder.assetName?.trim()) &&
      uploadedFiles.every((fileObj) => fileObj.assetName?.trim());
    const formData = new FormData();
    uploadedFiles.forEach((fileObj) => {
      formData.append("files", fileObj.file);
    });
    formData.append("product_id", id);
    const payload = {
      selectedFolders: selectedFolders.map((folder) => ({
        ...folder,
        path: folder.path || folder.full_path || folder.name,
        configuration: {
          assetName:
            fileConfigurations[folder.path]?.assetName || folder.assetName,
          assetDescription:
            fileConfigurations[folder.path]?.assetDescription ||
            folder.assetDescription,
          dataAssetOwner:
            fileConfigurations[folder.path]?.dataAssetOwner ||
            folder.dataAssetOwner,
          dataframeName:
            fileConfigurations[folder.path]?.dataframeName ||
            folder.dataframeName,
          region: fileConfigurations[folder.path]?.region || folder.region,
          market: fileConfigurations[folder.path]?.market || folder.market,
          technicalDataSteward:
            fileConfigurations[folder.path]?.technicalDataSteward ||
            folder.technicalDataSteward,
          completeness:
            fileConfigurations[folder.path]?.completeness ||
            folder.completeness ||
            "N/A",
          uniqueness:
            fileConfigurations[folder.path]?.uniqueness ||
            folder.uniqueness ||
            "N/A",
          freshness:
            fileConfigurations[folder.path]?.freshness ||
            folder.freshness ||
            "0",
          validity:
            fileConfigurations[folder.path]?.validity ||
            folder.validity ||
            "N/A",
          accuracy:
            fileConfigurations[folder.path]?.accuracy ||
            folder.accuracy ||
            "N/A",
          consistency:
            fileConfigurations[folder.path]?.consistency ||
            folder.consistency ||
            "N/A",
          sampleSize:
            fileConfigurations[folder.path]?.sampleSize ||
            folder.sampleSize ||
            10,
          tags: fileConfigurations[folder.path]?.tags || folder.tags || [],
          // Asset Ingestion Schedule Information
          frequency:
            fileConfigurations[folder.path]?.frequency ||
            folder.frequency ||
            "N/A",
          startDate:
            fileConfigurations[folder.path]?.startDate ||
            folder.startDate ||
            null,
          endDate:
            fileConfigurations[folder.path]?.endDate || folder.endDate || null,
          time:
            fileConfigurations[folder.path]?.time || folder.time || "00:00:00",
          daysOfWeek:
            fileConfigurations[folder.path]?.daysOfWeek ||
            folder.daysOfWeek ||
            [],
          dayOfMonth:
            fileConfigurations[folder.path]?.dayOfMonth ||
            folder.dayOfMonth ||
            "0",
          selectedPeriods:
            fileConfigurations[folder.path]?.selectedPeriods ||
            folder.selectedPeriods ||
            [],
        },
      })),
      uploadedFiles: uploadedFiles.map((file) => ({
        ...file,
        configuration: {
          assetName: fileConfigurations[file.id]?.assetName || file.assetName,
          assetDescription:
            fileConfigurations[file.id]?.assetDescription ||
            file.assetDescription,
          dataAssetOwner:
            fileConfigurations[file.id]?.dataAssetOwner || file.dataAssetOwner,
          dataframeName:
            fileConfigurations[file.id]?.dataframeName || file.dataframeName,
          region: fileConfigurations[file.id]?.region || file.region,
          market: fileConfigurations[file.id]?.market || file.market,
          technicalDataSteward:
            fileConfigurations[file.id]?.technicalDataSteward ||
            file.technicalDataSteward,
          completeness:
            fileConfigurations[file.id]?.completeness || file.completeness,
          uniqueness:
            fileConfigurations[file.id]?.uniqueness || file.uniqueness,
          freshness:
            fileConfigurations[file.id]?.freshness || file.freshness,
          validity: fileConfigurations[file.id]?.validity || file.validity,
          accuracy: fileConfigurations[file.id]?.accuracy || file.accuracy,
          consistency:
            fileConfigurations[file.id]?.consistency || file.consistency,
          sampleSize:
            fileConfigurations[file.id]?.sampleSize || file.sampleSize || 10,
          tags: fileConfigurations[file.id]?.tags || file.tags || [],
          // Asset Ingestion Schedule Information
          frequency:
            fileConfigurations[file.id]?.frequency || file.frequency || "N/A",
          startDate:
            fileConfigurations[file.id]?.startDate || file.startDate || null,
          endDate: fileConfigurations[file.id]?.endDate || file.endDate || null,
          time: fileConfigurations[file.id]?.time || file.time || "00:00:00",
          daysOfWeek:
            fileConfigurations[file.id]?.daysOfWeek || file.daysOfWeek || [],
          dayOfMonth:
            fileConfigurations[file.id]?.dayOfMonth || file.dayOfMonth || "0",
          selectedPeriods:
            fileConfigurations[file.id]?.selectedPeriods ||
            file.selectedPeriods ||
            [],
        },
      })),
      timestamp: new Date().toISOString(),
      totalItems: selectedFolders.length + uploadedFiles.length,
      product_id: id,
      created_by: localStorage.getItem("userId"),
    };
    formData.append("payload", JSON.stringify(payload));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/data-asset-versioning/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        setIsSaving(false);
        toast.success("Assets saved successfully!");
      } else {
        toast.error("Failed to save assets.");
        setIsSaving(false);
      }
    } catch (error) {
      // Check for duplicate key constraint error
      if (
        error.response?.status === 500 &&
        error.response?.data?.detail?.includes(
          "Violation of UNIQUE KEY constraint"
        )
      ) {
        toast.error(
          "This asset is already onboarded with some other product. Please choose different asset for onboarding."
        );
      } else {
        toast.error(
          "Failed to save. Please try again later. If the issue persists, contact hardik.talati@effem.com or amitoz.s.sidhu@effem.com for assistance."
        );
      }
      setIsSaving(false);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    // Validation check
    const allItemsHaveNames =
      selectedFolders.every((folder) => folder.assetName?.trim()) &&
      uploadedFiles.every((fileObj) => fileObj.assetName?.trim());

    const formData = new FormData();

    uploadedFiles.forEach((fileObj) => {
      formData.append("files", fileObj.file);
    });
    formData.append("product_id", id);

    const payload = {
      selectedFolders: selectedFolders.map((folder) => ({
        ...folder,
        path: folder.path || folder.full_path || folder.name,
        configuration: {
          assetName:
            fileConfigurations[folder.path]?.assetName || folder.assetName,
          assetDescription:
            fileConfigurations[folder.path]?.assetDescription ||
            folder.assetDescription,
          dataAssetOwner:
            fileConfigurations[folder.path]?.dataAssetOwner ||
            folder.dataAssetOwner,
          dataframeName:
            fileConfigurations[folder.path]?.dataframeName ||
            folder.dataframeName,
          region: fileConfigurations[folder.path]?.region || folder.region,
          market: fileConfigurations[folder.path]?.market || folder.market,
          technicalDataSteward:
            fileConfigurations[folder.path]?.technicalDataSteward ||
            folder.technicalDataSteward,
          completeness:
            fileConfigurations[folder.path]?.completeness ||
            folder.completeness,
          uniqueness:
            fileConfigurations[folder.path]?.uniqueness || folder.uniqueness,
          freshness:
            fileConfigurations[folder.path]?.freshness || folder.freshness,
          validity:
            fileConfigurations[folder.path]?.validity || folder.validity,
          accuracy:
            fileConfigurations[folder.path]?.accuracy || folder.accuracy,
          consistency:
            fileConfigurations[folder.path]?.consistency || folder.consistency,
          sampleSize:
            fileConfigurations[folder.path]?.sampleSize ||
            folder.sampleSize ||
            10,
          tags: fileConfigurations[folder.path]?.tags || folder.tags || [],
          // Asset Ingestion Schedule Information
          frequency:
            fileConfigurations[folder.path]?.frequency ||
            folder.frequency ||
            "N/A",
          startDate:
            fileConfigurations[folder.path]?.startDate ||
            folder.startDate ||
            null,
          endDate:
            fileConfigurations[folder.path]?.endDate || folder.endDate || null,
          time:
            fileConfigurations[folder.path]?.time || folder.time || "00:00:00",
          daysOfWeek:
            fileConfigurations[folder.path]?.daysOfWeek ||
            folder.daysOfWeek ||
            [],
          dayOfMonth:
            fileConfigurations[folder.path]?.dayOfMonth ||
            folder.dayOfMonth ||
            "0",
          selectedPeriods:
            fileConfigurations[folder.path]?.selectedPeriods ||
            folder.selectedPeriods ||
            [],
        },
      })),
      uploadedFiles: uploadedFiles.map((file) => ({
        ...file,
        configuration: {
          assetName: fileConfigurations[file.id]?.assetName || file.assetName,
          assetDescription:
            fileConfigurations[file.id]?.assetDescription ||
            file.assetDescription,
          dataAssetOwner:
            fileConfigurations[file.id]?.dataAssetOwner || file.dataAssetOwner,
          dataframeName:
            fileConfigurations[file.id]?.dataframeName || file.dataframeName,
          region: fileConfigurations[file.id]?.region || file.region,
          market: fileConfigurations[file.id]?.market || file.market,
          technicalDataSteward:
            fileConfigurations[file.id]?.technicalDataSteward ||
            file.technicalDataSteward,
          completeness:
            fileConfigurations[file.id]?.completeness || file.completeness,
          uniqueness:
            fileConfigurations[file.id]?.uniqueness || file.uniqueness,
          freshness:
            fileConfigurations[file.id]?.freshness || file.freshness,
          validity: fileConfigurations[file.id]?.validity || file.validity,
          accuracy: fileConfigurations[file.id]?.accuracy || file.accuracy,
          consistency:
            fileConfigurations[file.id]?.consistency || file.consistency,
          sampleSize:
            fileConfigurations[file.id]?.sampleSize || file.sampleSize || 10,
          tags: fileConfigurations[file.id]?.tags || file.tags || [],
          // Asset Ingestion Schedule Information
          frequency:
            fileConfigurations[file.id]?.frequency || file.frequency || "N/A",
          startDate:
            fileConfigurations[file.id]?.startDate || file.startDate || null,
          endDate: fileConfigurations[file.id]?.endDate || file.endDate || null,
          time: fileConfigurations[file.id]?.time || file.time || "00:00:00",
          daysOfWeek:
            fileConfigurations[file.id]?.daysOfWeek || file.daysOfWeek || [],
          dayOfMonth:
            fileConfigurations[file.id]?.dayOfMonth || file.dayOfMonth || "0",
          selectedPeriods:
            fileConfigurations[file.id]?.selectedPeriods ||
            file.selectedPeriods ||
            [],
        },
      })),
      timestamp: new Date().toISOString(),
      totalItems: selectedFolders.length + uploadedFiles.length,
      product_id: id,
      created_by: localStorage.getItem("userId"),
    };
    formData.append("payload", JSON.stringify(payload));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/data-asset-versioning/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || 201) {
        setColumnList(response?.data?.schemas);
        setIsSubmitting(false);
      }

      toast.success("Assets submitted successfully!");

      setTimeout(() => setColumnModalOpen(true), 1000);
    } catch (error) {
      console.error("Error submitting assets:", error);
      // Check for duplicate key constraint error
      if (
        error.response?.status === 500 &&
        error.response?.data?.detail?.includes(
          "Violation of UNIQUE KEY constraint"
        )
      ) {
        toast.error(
          "This asset is already onboarded with some other product. Please choose different asset for onboarding."
        );
      } else {
        toast.error(
          "Failed to submit asset. Please try again later. If the issue persists, contact hardik.talati@effem.com or amitoz.s.sidhu@effem.com for assistance."
        );
      }
      setIsSubmitting(false);
    }
  };

  const handleEditingNameChange = (id, value) => {
    setEditingNames((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleNameSave = (id, newName, isFolder) => {
    if (isFolder) {
      setSelectedFolders((prev) =>
        prev.map((folder) =>
          folder.path === id
            ? { ...folder, assetName: newName, isEditing: false }
            : folder
        )
      );
    } else {
      setUploadedFiles((prev) =>
        prev.map((fileObj) =>
          fileObj.id === id
            ? { ...fileObj, assetName: newName, isEditing: false }
            : fileObj
        )
      );
    }
    setEditingNames((prev) => {
      const { [id]: _, ...rest } = prev;
      return rest;
    });
  };

  const totalItems = selectedFolders.length + uploadedFiles.length;
  const adlsCount = useMemo(
    () => getAllSelectableItems(adlsData, "adls", isSelectableItem).length,
    [adlsData]
  );

  const openConfigModal = (isFile, itemSource, itemKey, itemName) => {
    setConfiguringFileId(itemKey);
    setConfiguringFileName(itemName);
    setConfiguringFileSource(itemSource);
    setIsFile(isFile);
    setConfigModalOpen(true);
  };

  const closeConfigModal = () => {
    setConfiguringFileId(null);
    setConfiguringFileName(null);
    setConfigModalOpen(false);
    setAssetNameCheckMessage("");
    setAssetNameIsUnique(undefined);
    setFormTouched(false);
  };

  // Populate form when opening config modal
  useEffect(() => {
    if (configModalOpen && configuringFileId) {
      const existing = fileConfigurations[configuringFileId] || {};
      const isAlreadyConfigured = Object.keys(existing).length > 0; // Check if configuration already exists
      setIsEditingExistingConfig(isAlreadyConfigured); // Set state for ConfigPopup

      //Pre-populate asset name based on asset source
      let assetNameBySource = "";

      if (configuringFileSource === "uc") {
        const filteredData = filterTree(ucData, configuringFileName);
        assetNameBySource =
          filteredData[0]?.children[0]?.name + "|" + configuringFileName;
      } else if (configuringFileSource === "uc_gcp") {
        const filteredData = filterTree(ucGcpData, configuringFileName);
        assetNameBySource =
          filteredData[0]?.children[0]?.name + "|" + configuringFileName;
      } else if (configuringFileSource === "adls") {
        // For ADLS, use the full path as-is
        assetNameBySource = configuringFileId;
      }

      const selectedAssetName = isFile ? "" : assetNameBySource;

      const assetName = existing.assetName || selectedAssetName;

      setConfigForm({
        assetName: assetName,
        assetDescription: existing.assetDescription || "",
        dataAssetOwner:
          existing.dataAssetOwner || localStorage.getItem("userId"),
        dataframeName: existing.dataframeName || "",
        tags: existing.tags || [],
        region:
          existing?.region ||
          (Array.isArray(onboardindDetails?.marketRegion)
            ? onboardindDetails?.marketRegion.join(", ")
            : onboardindDetails?.marketRegion),
        market:
          existing?.market ||
          (Array.isArray(onboardindDetails?.marketCountry)
            ? onboardindDetails?.marketCountry.join(", ")
            : onboardindDetails?.marketCountry),
        technicalDataSteward: existing.technicalDataSteward || "",
        completeness: existing.completeness || "",
        uniqueness: existing.uniqueness || "",
        freshness: existing.freshness || "0",
        validity: existing.validity || "",
        accuracy: existing.accuracy || "",
        consistency: existing.consistency || "",
        sampleSize: existing.sampleSize || 10,
        // Asset Ingestion Schedule Information
        frequency: existing.frequency || "",
        startDate: existing.startDate || "",
        endDate: existing.endDate || "",
        time: existing.time || "",
        daysOfWeek: existing.daysOfWeek || [],
        dayOfMonth: existing.dayOfMonth || "",
        selectedPeriods: existing.selectedPeriods || [],
      });
      setFormErrors({});

      // Only trigger asset name uniqueness check for NEW configurations (not already saved)
      if (assetName && !isAlreadyConfigured) {
        checkAssetNameUnique(assetName);
      } else if (isAlreadyConfigured) {
        // For already configured items, mark as valid so fields are enabled
        setAssetNameIsUnique(true);
        setDisableAllFields(false);
      }
    }
  }, [configModalOpen, configuringFileId, onboardindDetails]);

  const handleConfigChange = (e) => {
    const { name, value } = e.target;

    // Validate numeric fields to ensure they don't exceed 100
    if (
      ["completeness", "accuracy", "consistency", "sampleSize", "freshness"].includes(name)
    ) {
      const numValue = Number(value);
      if (numValue > 100) {
        // Don't update the form if value exceeds 100
        return;
      }
    }

    setConfigForm((prev) => ({ ...prev, [name]: value }));
    if (name === "assetName") {
      setAssetNameCheckMessage("");
      setAssetNameIsUnique(undefined);
      if (debounceTimeout) clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        checkAssetNameUnique(value);
      }, 600);
    }
  };

  const checkAssetNameUnique = async (name) => {
    if (!name) {
      setAssetNameCheckMessage("");
      setAssetNameIsUnique(undefined);
      setDisableAllFields(true);
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/data-asset/check?name=${name}`
      );
      if (response.data) {
        setAssetNameCheckMessage(response.data.message);
        setAssetNameIsUnique(!response.data.matched);
        setDisableAllFields(response.data.matched);
      } else {
        setAssetNameCheckMessage("");
        setAssetNameIsUnique(undefined);
        setDisableAllFields(true);
      }
    } catch (error) {
      setAssetNameCheckMessage("Error checking asset name");
      setAssetNameIsUnique(undefined);
      setDisableAllFields(true);
    }
  };


  useEffect(() => {
    // Disable all fields if asset name is not unique or empty
    if (!configForm.assetName || assetNameIsUnique === false) {
      setDisableAllFields(true);
    } else {
      setDisableAllFields(false);
    }
  }, [configForm.assetName, assetNameIsUnique]);

  const validateConfigForm = () => {
    const errors = {};
    if (!configForm.assetName) errors.assetName = "Required";
    if (!configForm.assetDescription) errors.assetDescription = "Required";
    if (!configForm.dataAssetOwner) {
      errors.dataAssetOwner = "Required";
    } else {
      // Email format validation - only @effem.com domain allowed
      const ALLOWED_EMAIL_DOMAINS = ["effem.com"];
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = configForm.dataAssetOwner.match(emailPattern);
      if (!match || !ALLOWED_EMAIL_DOMAINS.includes(match[1])) {
        errors.dataAssetOwner = `Email must be from: ${ALLOWED_EMAIL_DOMAINS.join(
          ", "
        )}`;
      }
    }
    if (!configForm.dataframeName) errors.dataframeName = "Required";
    if (!configForm.region) errors.region = "Required";
    if (!configForm.market) errors.market = "Required";
    if (!configForm.technicalDataSteward) {
      errors.technicalDataSteward = "Required";
    } else {
      // Email format validation - only @effem.com domain allowed
      const ALLOWED_EMAIL_DOMAINS = ["effem.com"];
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = configForm.technicalDataSteward.match(emailPattern);
      if (!match || !ALLOWED_EMAIL_DOMAINS.includes(match[1])) {
        errors.technicalDataSteward = `Email must be from: ${ALLOWED_EMAIL_DOMAINS.join(
          ", "
        )}`;
      }
    }
    if (!configForm.freshness || Number(configForm.freshness) < 0)
      errors.freshness = "Min value is 0";
    if (!configForm.completeness || Number(configForm.completeness) < 0)
      errors.completeness = "Min value is 0";
    if (!configForm.uniqueness || Number(configForm.uniqueness) < 0)
      errors.uniqueness = "Min value is 0";
    if (!configForm.validity || Number(configForm.validity) < 0)
      errors.validity = "Min value is 0";
    if (!configForm.accuracy || Number(configForm.accuracy) < 0)
      errors.accuracy = "Min value is 0";
    if (!configForm.consistency || Number(configForm.consistency) < 0)
      errors.consistency = "Min value is 0";
    if (
      !configForm.sampleSize ||
      Number(configForm.sampleSize) < 1 ||
      Number(configForm.sampleSize) > 100
    )
      errors.sampleSize = "Sample size must be between 1 and 100";

    // New validation for Schedule Information
    if (!configForm.frequency) errors.frequency = "Required";
  
    if (
      configForm.frequency &&
      configForm.frequency !== "Hourly" &&
      !configForm.time
    ) {
      errors.time = "Time is required for selected frequency";
    }

    // Conditional validation based on frequency specifics
    if (configForm.frequency === "Weekly") {
      if (!configForm.daysOfWeek || configForm.daysOfWeek.length === 0) {
        errors.daysOfWeek =
          "At least one day must be selected for Weekly frequency";
      }
    }
    if (configForm.frequency === "Mars Periodic") {
      if (!configForm.dayOfMonth) {
        errors.dayOfMonth = "Day is required for Mars Periodic frequency";
      }
    }
    if (configForm.frequency === "Mars Quarter") {
      if (
        !configForm.selectedPeriods ||
        configForm.selectedPeriods.length === 0
      ) {
        errors.selectedPeriods =
          "At least one period must be selected for Mars Quarter";
      }
      if (!configForm.dayOfMonth) {
        errors.dayOfMonth = "Day is required for Mars Quarter frequency";
      }
    }
    if (configForm.frequency === "Mars Year") {
      if (
        !configForm.selectedPeriods ||
        configForm.selectedPeriods.length === 0
      ) {
        errors.selectedPeriods = "One period must be selected for Mars Year";
      }
      if (!configForm.dayOfMonth) {
        errors.dayOfMonth = "Day is required for Mars Year frequency";
      }
    }
    if (configForm.frequency === "Mars Half-Yearly") {
      if (
        !configForm.selectedPeriods ||
        configForm.selectedPeriods.length === 0
      ) {
        errors.selectedPeriods =
          "At least one period must be selected for Mars Half-Yearly";
      }
      if (!configForm.dayOfMonth) {
        errors.dayOfMonth = "Day is required for Mars Half-Yearly frequency";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Helper to check if all required fields are filled (not format-validated)
  const areAllFieldsFilled = () => {
    // Validate Data Asset Owner email domain
    const isDataAssetOwnerValid = () => {
      if (!configForm.dataAssetOwner) return false;
      const ALLOWED_EMAIL_DOMAINS = ["effem.com"];
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = configForm.dataAssetOwner.match(emailPattern);
      return match && ALLOWED_EMAIL_DOMAINS.includes(match[1]);
    };

    // Validate Technical Data Steward email domain
    const isTechnicalStewardValid = () => {
      if (!configForm.technicalDataSteward) return false;
      const ALLOWED_EMAIL_DOMAINS = ["effem.com"];
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = configForm.technicalDataSteward.match(emailPattern);
      return match && ALLOWED_EMAIL_DOMAINS.includes(match[1]);
    };

    const baseFields =
      configForm.assetName &&
      configForm.assetDescription &&
      isDataAssetOwnerValid() &&
      configForm.dataframeName &&
      configForm.region &&
      configForm.market &&
      isTechnicalStewardValid() &&
      configForm.completeness &&
      configForm.uniqueness &&
      configForm.validity &&
      configForm.accuracy &&
      configForm.consistency &&
      configForm.sampleSize &&
      configForm.frequency;
    const needsTime = configForm.frequency && configForm.frequency !== "Hourly";
    const timeOk = needsTime ? !!configForm.time : true;

    if (configForm.frequency === "Weekly") {
      return (
        baseFields &&
        timeOk &&
        configForm.daysOfWeek &&
        configForm.daysOfWeek.length > 0
      );
    }
    if (configForm.frequency === "Mars Periodic") {
      return baseFields && timeOk && configForm.dayOfMonth;
    }
    if (configForm.frequency === "Mars Quarter") {
      return (
        baseFields &&
        timeOk &&
        configForm.selectedPeriods &&
        configForm.selectedPeriods.length > 0 &&
        configForm.dayOfMonth
      );
    }
    if (configForm.frequency === "Mars Yearly") {
      return (
        baseFields &&
        timeOk &&
        configForm.selectedPeriods &&
        configForm.selectedPeriods.length > 0 &&
        configForm.dayOfMonth
      );
    }
    if (configForm.frequency === "Mars Half-Yearly") {
      return (
        baseFields &&
        timeOk &&
        configForm.selectedPeriods &&
        configForm.selectedPeriods.length > 0 &&
        configForm.dayOfMonth
      );
    }
    if (configForm.frequency === "Daily") {
      return baseFields && timeOk;
    }
    if (configForm.frequency === "Hourly") {
      return baseFields; // No additional fields required for Hourly
    }

    return baseFields && timeOk;
  };

  useEffect(() => {
    // Enable Save if all fields are filled and not globally disabled
    if (!disableAllFields) {
      setAllFieldsValid(areAllFieldsFilled());
    } else {
      setAllFieldsValid(false);
    }
    // eslint-disable-next-line
  }, [configForm, disableAllFields]);

  const handleConfigSave = () => {
    setFormTouched(true);
    // Now do full validation (including email format)
    if (!validateConfigForm()) return;
    setFileConfigurations((prev) => ({
      ...prev,
      [configuringFileId]: { ...configForm },
    }));
    closeConfigModal();
  };

  // Validation: all selectedFolders and uploadedFiles must be configured
  const allFoldersConfigured = selectedFolders.every(
    (item) => fileConfigurations[item.path]
  );
  const allFilesConfigured = uploadedFiles.every(
    (file) => fileConfigurations[file.id]
  );
  const allItemsConfigured = allFoldersConfigured && allFilesConfigured;

  // Column selection modal logic

  console.log("columnSubmitting", columnSubmitting);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..." className="h-30" />
          <span className="text-gray-700 text-[20px]">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }

  return (
    <>
      {!columnModalOpen && (
        <>
          <div className="flex flex-col  w-full h-[100%] min-h-[600px] p-6 bg-white">
            <div className="p-6  pt-0 border-b">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <h2 className="text-xl font-bold text-[#bb1ccc]">
                    Data Asset Selection
                  </h2>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-sm font-medium bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
                    {totalItems} total items
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-grow flex overflow-hidden">
              <AssetSelectionSidebar
                activeTab={activeTab}
                availableTabs={availableTabs}
                setActiveTab={setActiveTab}
                selectedFolders={selectedFolders}
                uploadedFiles={uploadedFiles}
                adlsData={adlsData}
                ucData={ucData}
                ucGcpData={ucGcpData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isDragActive={isDragActive}
                handleDrag={handleDrag}
                handleDrop={handleDrop}
                handleFileChange={handleFileChange}
                handleSelectAll={handleSelectAll}
                handleClear={handleClear}
                handleItemSelect={handleItemSelect}
                loading={loading || loadingAssets}
                ErrorMessage={ErrorMessage}
              />
              <SelectedItemsPanel
                selectedFolders={selectedFolders}
                uploadedFiles={uploadedFiles}
                handleNameSave={handleNameSave}
                onEditingNameChange={handleEditingNameChange}
                editingNames={editingNames}
                fileConfigurations={fileConfigurations}
                openConfigModal={openConfigModal}
                handleRemoveFolder={handleRemoveFolder}
                handleRemoveFile={handleRemoveFile}
                allItemsConfigured={allItemsConfigured}
                isSaving={isSaving}
                isSubmitting={isSubmitting}
                handleSave={handleSave}
                handleSubmit={handleSubmit}
                columnModalOpen={columnModalOpen}
              />
            </div>
          </div>
          <Toaster position="top-right" />
          <ConfigPopup
            configForm={configForm}
            configModalOpen={configModalOpen}
            closeConfigModal={closeConfigModal}
            handleConfigChange={handleConfigChange}
            formErrors={formErrors}
            handleConfigSave={handleConfigSave}
            disableAllFields={disableAllFields}
            assetNameCheckMessage={assetNameCheckMessage}
            assetNameIsUnique={assetNameIsUnique}
            allFieldsValid={allFieldsValid}
            formTouched={formTouched}
            regionsCountriesData={regionsCountriesData}
            setConfigForm={setConfigForm}
            isEditingExistingConfig={isEditingExistingConfig}
          />
        </>
      )}

      {columnModalOpen && (
        <ColumnSelection
          nextStep={nextStep}
          columnsList={columnsList}
          id={id}
          setLoading={setLoading}
        />
      )}
    </>
  );
};

export default AssetSelectionModal;
